import { render, staticRenderFns } from "./kycFile.vue?vue&type=template&id=71240ce5&scoped=true&"
import script from "./kycFile.vue?vue&type=script&lang=js&"
export * from "./kycFile.vue?vue&type=script&lang=js&"
import style0 from "./kycFile.vue?vue&type=style&index=0&id=71240ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71240ce5",
  null
  
)

export default component.exports